import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";

import DateTimePicker from "editor/components/DateTimePicker";
import Button from "components/library/Button";

import { DATETIME_FORMAT } from "config/constants";
import styles from "./DateTimeForm.css";

class DateTimeForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
    this.setDateTime = this._setDateTime.bind(this);
    this.close = this._close.bind(this);
  }

  _setDateTime(value) {
    this.close();
    this.props.updateFormAt(this.props.field, value);
  }

  _close() {
    this.setState({ isOpen: false });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.featured_sections !== this.props.featured_sections &&
      !this.props.featured_sections.length
    ) {
      this.setDateTime(null);
    }
  }

  render() {
    let datetime = moment(this.props.value).format(DATETIME_FORMAT);
    return (
      <>
        {this.props.value && (
          <span className={styles.text}>
            {this.props.setText} {datetime}.
          </span>
        )}
        {this.state.isOpen ? (
          <DateTimePicker
            value={this.props.value}
            onSubmit={this.setDateTime}
            onCancel={this.close}
            formText={this.props.formText}
            buttonText={this.props.buttonText}
          />
        ) : (
          <Button
            isDisabled={this.props.disabled}
            type="secondary"
            onClick={() => this.setState({ isOpen: true })}
          >
            {this.props.value
              ? `Edit ${this.props.buttonText}`
              : `Schedule ${this.props.buttonText}`}
          </Button>
        )}
      </>
    );
  }
}

DateTimeForm.propTypes = {
  value: PropTypes.object,
  disabled: PropTypes.bool,
  updateFormAt: PropTypes.func.isRequired,
  featured_sections: PropTypes.arrayOf(PropTypes.object),
  field: PropTypes.string,
  buttonText: PropTypes.string,
  formText: PropTypes.string,
  setText: PropTypes.node,
};

export default DateTimeForm;
